import { JURISDICTIONS } from '../../../constants/jurisdictions.ts';

const JurisdictionList = JURISDICTIONS;

export default JurisdictionList;
